import { downgradeComponent } from "@angular/upgrade/static";
import { CheckboxComponent } from "@directives/_forms/checkbox/checkbox.component";
import { CheckboxesComponent } from "@directives/_forms/checkboxes/checkboxes.component";
import { VFlagToggleListItemComponent } from "@directives/_forms/v-flag-toggle-list-item/v-flag-toggle-list-item.component";
import { VFlagToggleComponent } from "@directives/_forms/v-flag-toggle/v-flag-toggle.component";
import { VInputComponent } from "@directives/_forms/v-input/v-input.component";
import { VToggleListItemComponent } from "@directives/_forms/v-toggle-list-item/v-toggle-list-item.component";
import * as angular from "angular";
import { AutocompleteComponent } from "./autocomplete/autocomplete.component";
import { AutoFocus } from "./autocomplete/autocompleteFocus.directive";
import { CompareToDirective } from "./compareTo.directive";
import { FileDragDropDirective } from "./fileDragDrop.directive";
import { FileSelectedDirective } from "./fileSelected.directive";
import { FileUploadComponent } from "./fileUpload/fileUpload.component";
import { FormDetailsComponent } from "./formDetails/formDetails.component";
import { SmsInputComponent } from "./smsInput/sms-input.component";
import { TextareaComponent } from "./textarea/textarea.component";
import { VEnumSelectComponent } from "./v-enum-select/v-enum-select.component";
import { VOrderButtonsComponent } from "./v-order-buttons/v-order-buttons.component";
import { VRadioButtonComponent } from "./v-radio-button/v-radio-button.component";
import { VSelectOptionComponent } from "./v-select/v-select-option/v-select-option.component";
import { VSelectComponent } from "./v-select/v-select.component";
import { VSliderComponent } from "./v-slider/v-slider.component";
import { VToggleComponent } from "./v-toggle/v-toggle.component";
import { ValidatePasswordDirective } from "./validatePassword.directive";
import { ValidationFunctionDirective } from "./validationFunction.directive";
import { GroupNameValidator } from "./validators/groupNameValidator";
import { ReportNameValidator } from "./validators/reportNameValidator";
import { UserEmailDirective } from "./validators/userEmail";
import { VerifyCurrentPasswordDirective } from "./verifyCurrentPassword";
import { RadioButtonBaseComponent } from "./_radio-buttons/radio-button-base/radio-button-base.component";
import { RadioButtonCardsComponent } from "./_radio-buttons/radio-button-cards/radio-button-cards.component";
import { RadioButtonSmallCardsComponent } from "./_radio-buttons/radio-button-small-cards/radio-button-small-cards.component";

export const FormModuleName = "app.form.directives";

angular
    .module(FormModuleName ,[])
    .component("veriAutocomplete", new AutocompleteComponent())
    .directive("fileUpload", downgradeComponent({ component: FileUploadComponent }))
    .directive("smsInput", downgradeComponent({ component: SmsInputComponent }))
    .directive("formDetails", downgradeComponent({ component: FormDetailsComponent }))

    .directive("vInput", downgradeComponent({ component: VInputComponent }))
    .directive("vTextarea", downgradeComponent({ component: TextareaComponent }))

    .directive("fileDragDrop", FileDragDropDirective.factory())
    .directive("fileSelected", FileSelectedDirective.factory())
    .directive("compareTo", CompareToDirective.factory())
    .directive("userEmail", UserEmailDirective.factory())

    .directive("autoFocus", AutoFocus.factory())
    .directive("validatePassword", ValidatePasswordDirective.factory())
    .directive("verifyCurrentPassword", VerifyCurrentPasswordDirective.factory())
    .directive("groupNameValidator", GroupNameValidator.factory())
    .directive("reportNameValidator", ReportNameValidator.factory())
    .directive("validationFunction", ValidationFunctionDirective.factory())

    .directive("vToggle", downgradeComponent({ component: VToggleComponent }))
    .directive("vSelect", downgradeComponent({ component: VSelectComponent }))
    .directive("vSelectOption", downgradeComponent({ component: VSelectOptionComponent }))
    .directive("vEnumSelect", downgradeComponent({ component: VEnumSelectComponent }))

    .directive("vToggleListItem", downgradeComponent({ component: VToggleListItemComponent }))
    .directive("vFlagToggle", downgradeComponent({ component: VFlagToggleComponent }))
    .directive("vFlagToggleListItem", downgradeComponent({ component: VFlagToggleListItemComponent }))
    .directive("vCheckbox", downgradeComponent({ component: CheckboxComponent }))
    .directive("vCheckboxes", downgradeComponent({ component: CheckboxesComponent }))

    .directive("vSlider", downgradeComponent({ component: VSliderComponent }))
    .directive("vOrderButtons", downgradeComponent({ component: VOrderButtonsComponent }))

    .directive("vRadioButtonBase", downgradeComponent({ component: RadioButtonBaseComponent }))
    .directive("vRadioButtonCards", downgradeComponent({ component: RadioButtonCardsComponent }))
    .directive("vRadioButtonSmallCards", downgradeComponent({ component: RadioButtonSmallCardsComponent }))
    .directive("vRadioButton", downgradeComponent({ component: VRadioButtonComponent }))
